import React from "react"
import styled from "styled-components"

const SummaryTable = ({
  yearsToInvest,
  retirementFund,
  lifetimeSalary,
  totalSaved,
  earnedInterest,
}) => {
  return (
    <Container>
      <label>
        Years to invest: &nbsp;<p>{yearsToInvest}</p>
      </label>
      <label>
        Retirement fund: &nbsp;
        <p>{retirementFund}</p>
      </label>
      <label>
        Lifetime salary: &nbsp;
        <p>{lifetimeSalary}</p>
      </label>
      <label>
        Total saved: &nbsp;<p>{totalSaved}</p>
      </label>
      <label>
        Earned interest: &nbsp;<p>{earnedInterest}</p>
      </label>
    </Container>
  )
}

export default SummaryTable

const Container = styled.div`
  /* background: lightsalmon; */
  font-size: 1.1rem;
  width: 380px;
  label {
    display: flex;
    justify-content: flex-end;

    :not(:first-child) {
      margin-top: 12px;
    }
  }

  p {
    /* background: yellow; */
    width: 100px;
    text-align: center;
  }
`
